import { Avatar, Collapse, List, ListItem, Typography } from "@material-ui/core";
import _ from "lodash";
import React, { useEffect } from "react";
import { useStyles, Accordion, AccordionSummary } from '../styles/AccordionPodium';

export default function AccordionPodium(props) {
    const { eventoProva } = props;
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const [coloados, setColocados] = React.useState([])
    const handleChange = () => {
        setExpanded(!expanded);
    };


    const nomeProva = (prova) => {
        let fase = '';
        if (prova.tipo_fase === 'F') {
            fase = 'Final'
        }

        return `${fase} ${prova.sexo === 'F' ? 'Feminino' : 'Masculino'} ${prova.altura.descricao} ${prova.altura.descricao === prova.aparelho.descricao ? '' : prova.aparelho.descricao} ${prova.classe.descricao}`
    }

    useEffect(() => {
        // If colocacao exists, sort by it. Otherwise, sort by nota_final (descending)
        let classificacao;
        const hasColocacao = eventoProva.classificacao.some(item => item.colocacao !== null);

        if (hasColocacao) {
            // Sort by official ranking
            classificacao = _.orderBy(eventoProva.classificacao, ['colocacao'], ['asc']);
        } else {
            // Sort by nota_final descending (highest score first)
            // Put athletes with scores first, then those without scores
            classificacao = _.orderBy(
                eventoProva.classificacao,
                [
                    (item) => item.nota_final !== null ? 1 : 0, // Athletes with scores first
                    (item) => item.nota_final !== null ? parseFloat(item.nota_final) : 0
                ],
                ['desc', 'desc']
            );
        }

        setColocados(classificacao.slice(0, 3)); // Top 3 only
    }, [eventoProva])

    return (
        <div className={classes.root}>
            <Accordion expanded={expanded} onChange={handleChange} className={classes.Accordion}>
                <AccordionSummary>
                    <Typography className={classes.heading}>
                        {nomeProva(eventoProva)}
                    </Typography>
                </AccordionSummary>
            </Accordion>
            <Collapse in={expanded} className={classes.Collapse}>
                <List className={classes.ListPodium}>
                    {coloados.length > 0 ? (
                        coloados.map((item, key) => (
                            <ListItem key={key} className={`pos-${item.colocacao || (key + 1)}`}>
                                <Avatar />
                                <div>
                                    <Typography variant="body2" className={classes.nome}>
                                        {item.nome_completo.split(' ')[0]}
                                    </Typography>
                                    <Typography variant="body2" className={classes.sobrenome}>
                                        {item.nome_completo.split(' ').slice(1).join(' ')}
                                    </Typography>
                                </div>
                                <div className={classes.pontuacao}>
                                    {item.nota_final || '-'}
                                </div>
                            </ListItem>
                        ))
                    ) : (
                        <Typography style={{ padding: 20, textAlign: 'center' }}>
                            Nenhum atleta inscrito
                        </Typography>
                    )}
                </List>
            </Collapse>
        </div>
    )
}